import { Link } from 'react-router-dom';

import { ROUTE_FEEDBACK } from '../constants/routes';
import styles from './Footer.module.scss';

export const Footer = () => (
  <footer className={styles.Footer}>
    <div className={styles.FooterBody}>
      <p className={styles.FooterTitle}>
        Методическая поддержка системы осуществляется Минэкономразвития России. Оператором системы является Генеральная
        прокуратура Российской Федерации.
      </p>
      <p className={styles.FooterTitle}>
        Прием обращений в службу технической поддержки осуществляется по&nbsp;
        {window.location.pathname.includes(ROUTE_FEEDBACK) ? (
          <a href={`${ROUTE_FEEDBACK}#feedbackForm`}>форме обратной связи</a>
        ) : (
          <Link to={ROUTE_FEEDBACK}>форме обратной связи</Link>
        )}
        .
      </p>
    </div>
  </footer>
);
